import {
  Component,
  ElementRef,
  HostListener,
  Input,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ChangeDetectorRef,
} from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EndorsementPopupComponent } from "../../../popup/endorsement-popup/endorsement-popup.component";
import { POLICY_MOVEMENT_DATA, STORE_ENDORSEMENT } from '@store/sat-motor/sat-motor.action';
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { PolicyMovementPopupComponent } from "./policy-movement-popup/policy-movement-popup.component";
import { Subject, debounceTime, of, takeUntil } from "rxjs";

@Component({
  selector: 'app-policy-movement',
  standalone: true,
  imports: [
    SharedModule,
    PolicyMovementPopupComponent,
    EndorsementPopupComponent,
  ],
  templateUrl: './policy-movement.component.html',
  styleUrl: './policy-movement.component.scss'
})
export class PolicyMovementComponent {

  @Select(SatMotorState.motorActionType) actionType$;
  @Select(SatMotorState.endtVehiclePolicy) endtVehiclePolicyData$;
  // @Select(SatMotorState.policyMovemementTableData) policyMovemementTableData$;

  templateDialogRef?: NxModalRef<any>;
  // componentDialogRef?: NxModalRef<CoverageComponent>;
  componentDialogRef?: NxModalRef<PolicyMovementPopupComponent>;

  @ViewChild("template") templateRef!: TemplateRef<any>;
  @ViewChild("template2") templateRef2!: TemplateRef<any>;
  @ViewChild("templatePolicyTable") templateRef3!: TemplateRef<any>;
  @ViewChild("autosize") autosize!: CdkTextareaAutosize;
  @ViewChild('tableHeader', { static: false }) tableHeader: ElementRef<HTMLTableHeaderCellElement>;

  @Input() endorsementType: any;

  pageFilterForm: FormGroup;
  unsubscribe$ = new Subject();
  itemsPerPageSelections = [5, 10, 20, 30, 40, 50];
  curpage: number = 1;
  perPage: number = 5;
  count: number = 0;
  showPagination: boolean = false;

  policyNo: any;
  policyMovemementTableData: any;
  endorsementTypeListOfValues: any;
  selectedPolicyMovement: any;

  tableHolder: any;
  endorsement_details = true;
  page = 1;
  
  constructor(
    private readonly dialogService: NxDialogService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store
  ) { }

  ngOnInit(): void {

    this.prepareEndorsementTypeListLov();
    this.loadPolicyMovementTable();

    this.pageFilterForm = this.fb.group({
      perPage: [this.perPage]
    });

  }

  prepareEndorsementTypeListLov(): any {
    const lov = this.store.selectSnapshot<any>(state => state.SatMotorState?.lov);
    this.endorsementTypeListOfValues = lov?.endorsementList;
  }

  loadPolicyMovementTable() {
    this.endtVehiclePolicyData$.subscribe((state) => {
      if (state) {
        this.policyNo = state.policyNo;
        let payload = {
          policyNo: this.policyNo,
          transactionNo: ""
        };

        this.store.dispatch(new POLICY_MOVEMENT_DATA(payload)).subscribe(() => {
          this.policyMovemementTableData = this.store.selectSnapshot<any>(state => state.SatMotorState?.data?.step2?.endorsementDetails?.policyMovemementData);
          this.policyMovemementTableData = this.policyMovemementTableData.map((item) => {

            return {
              ...item,
              endorsementDesc: item.endorsementDesc ? item.endorsementDesc.toUpperCase() : "Type Not Found",
              effectiveDate: this.formatDate(item.effectiveDate),
              expiryDate: this.formatDate(item.expiryDate),
              sumInsured: this.formatSumInsured(item.sumInsured),
              premiumDue: this.formatSumInsured(item.premiumDue),
              vehicleNo: item.vehicleNo ? item.vehicleNo.toUpperCase() : item.vehicleNo,
            };
          });

          if (this.policyMovemementTableData && this.policyMovemementTableData.length > 5) {
            this.showPagination = true;
          }
          this.setItemPerPage();
        });
      }
    });
  }

  scrollIntoView() {
    //window.scroll({ top: 0, left: 0, behavior: 'instant' });
    //document.querySelector('.clickable_table').scrollIntoView({ behavior: 'smooth', block: 'start' });
    document.querySelector('nx-expansion-panel-header').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  get totalPages(): number {
    return Math.ceil(this.policyMovemementTableData.length / this.perPage);
  }

  get paginatedData(): any[] {
    const startIndex = (this.page - 1) * this.perPage;
    const endIndex = startIndex + this.perPage;
    return this.policyMovemementTableData.slice(startIndex, endIndex);
  }

  onPerPageChange(newPerPage: number): void {
    this.perPage = newPerPage;
    this.page = 1;
  }

  openDialog(template: TemplateRef<any>, config: { height?: string; width?: string } = {}): void {
    this.templateDialogRef = this.dialogService.open(template, {
      disableClose: true,
      height: config.height || '500px',
      width: config.width || '780px',
    });
  }

  closeDialog(): void {
    this.templateDialogRef?.close();
  }

  setItemPerPage() {
    this.pageFilterForm.get('perPage').valueChanges.pipe(
      debounceTime(250),
      takeUntil(this.unsubscribe$)
    ).subscribe((value) => {
      this.perPage = value;
      this.curpage = 1;
      this.scrollIntoView();
    });
  }

  get paginatedResults() {
    if (this.policyMovemementTableData) {
      const startIndex = (this.curpage - 1) * this.perPage;
      return this.policyMovemementTableData.slice(startIndex, startIndex + this.perPage);
    }
    return [];
  }

  getResultLength() {
    if (this.policyMovemementTableData) {
      return this.policyMovemementTableData.length;
    }
    return 0;
  }

  prevPage() {
    this.curpage--;
    this.scrollIntoView();
  }

  nextPage() {
    this.curpage++;
    this.scrollIntoView();
  }

  goToPage(n: number) {
    this.curpage = n;
    this.scrollIntoView();
  }

  formatDate = (date) => {
    if (date) {
      const d = new Date(date);
      // return d.toLocaleDateString('ms-MY');
      const day = ('0' + d.getDate()).slice(-2); // Pad day with leading zero
      const month = ('0' + (d.getMonth() + 1)).slice(-2); // Pad month with leading zero
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return 'Invalid Date';
  };

  formatSumInsured = (amount) => {
    return parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  policyTable(): void {
    this.templateDialogRef = this.dialogService.open(this.templateRef3, {
      disableClose: true,
      height: "500px",
    });
  }

  closeTemplateDialog() {
    this.templateDialogRef?.close();
  }

  // componentDialogRef1?: NxModalRef<PolicyMovementPopupComponent>;
  componentDialogRef1?: NxModalRef<EndorsementPopupComponent>;

  openPopup3(item: any) {
    // Set the selectedPolicyMovement to the item clicked by the user
    this.selectedPolicyMovement = item;

    // Open the PolicyMovementPopupComponent dialog and pass the selected data
    this.componentDialogRef = this.dialogService.open(PolicyMovementPopupComponent, {
      ariaLabel: "Policy Movement Details",
      showCloseIcon: false,
      disableClose: true,
      data: { popup_type: 'policyTable', selectedPolicyMovement: this.selectedPolicyMovement },
      // width: '600px', // Set width based on your design
    });
  }

  closePopup() {
    this.componentDialogRef?.close();
  }

}
